import Utils from '../../vue/utils';
import Filters from '../../vue/filters/filters';
import { getCaretPos, setCaretPos } from '../../utils.js';
import { nextTick } from 'vue';

/* eslint no-unused-vars: "off" */

const updateElementMoneyValue = (element, binding, vnode) => {
	if (element == null || binding == null || vnode == null) {
		return;
	}
	
	element.value = Filters.formatMoney(element.value, binding.value);
};

function focusBlurHandler(el) {
	let currentVal;

	el.addEventListener('focus', (e) => {
		currentVal = e.target.value;
		e.target.value = '';
	});

	el.addEventListener('blur', (e) => {
		e.target.value = el.value || currentVal;
	});
}

export const maskNumeric = {
    mounted: function (el, binding, vnode) {
        (function (vnode) {
            var modelName = Utils.getModelName(vnode);
            el.addEventListener('input', function (e) {
                var newValue = Utils.format(e.target.value);
                if (newValue === e.target.value) {
                    return;
                }
                var selectionPosition;
                if ('selectionStart' in e.target && 'selectionEnd' in e.target) {
                    selectionPosition = e.target.selectionStart - (e.target.value.length - newValue.length);
                    if (selectionPosition < 0) {
                        selectionPosition = 0;
                    }
                }
                e.target.value = newValue;
                if ('selectionStart' in e.target && 'selectionEnd' in e.target) {
                    e.target.selectionStart = selectionPosition;
                    e.target.selectionEnd = selectionPosition;
                }
                if (modelName != null && !Utils.isModelHasLazy(vnode)) {
                    vnode.context[modelName] = newValue;
                }
            });
        })(vnode);
    }
};

export const money = {
    mounted(el, binding, vnode) {
				el.addEventListener('blur', function (e) {
						updateElementMoneyValue(e.target, binding, vnode);
				});
				el.addEventListener('focus', function (e) {
						var newValue = Utils.float(Utils.format(e.target.value));
						if (newValue === e.target.value) {
								return;
						}

						if (newValue > 0) e.target.value = newValue;
				});
				if (el.value) updateElementMoneyValue(el, binding, vnode)
    },
    updated(element, binding, vnode) {
        if (document.activeElement !== element) {
            if (element.value) updateElementMoneyValue(element, binding, vnode)
        }
    }
};

export const focus = {
	'mounted': function (el) {
		el.focus();
	}
};

export const stepProgress = {
	updated(el, binding) {
		if (el.type == 'checkbox') {
			nextTick(() => {
				document.getElementById(el.id).parentElement.addEventListener('click', () => {
					binding.instance.setFilledStepLine();
				})
			})
		} else {
			nextTick(() => {
				binding.instance.setFilledStepLine();
			})
		}
	}
}

export const phone = {
	mounted: (el, binding, vnode) => {
		el.addEventListener('keydown', (e) => {
			vnode.context.phoneStartsAtEight = false;
			if ( el.value.length <= 3 && e.key === '8' ) {
				e.preventDefault();
				vnode.context.phoneStartsAtEight = true;
			}

			// сохранение позиции курсора при удалении цифр в номере
			if (e.key === 'Backspace' || e.key === 'Delete') {
				let caretPos = getCaretPos(el);

				// если кандидат на стирание не цифра (тире, например)
				if (e.key === 'Delete' && !isFinite(el.value[caretPos])) {
					setTimeout(() => {
						setCaretPos(el, caretPos+1);
						let x = el.value.split('');
						x.splice((caretPos+1), 1);
						el.value = x.join('');
						setCaretPos(el, caretPos);
					}, 10)

					return
				}

				setTimeout(() => {
					setCaretPos(el, e.key === 'Delete' ? caretPos : caretPos-1);
				}, 10)
			}
			// если цифра
			if (isFinite(e.key)) {
				let caretPos = getCaretPos(el);

				// если есть символ после каретки
				if (el.value[caretPos+1]) {
					setTimeout(() => {
						setCaretPos(el, caretPos+1);
					}, 10)
				}
			}
		})
	},
}

export default function registerVueDirectives(app) {
	app.directive('maskNumeric', maskNumeric);

	app.directive('model-min-value', {
		bind: function (el, binding, vnode) {
			if (!(binding.expression in vnode.context)) {
				return;
			}
			var getMinModelValueOrNull = function (binding, vnode, newValue) {
				var formattedValue = newValue,
					minValue = vnode.context[binding.expression],
					modelName = Utils.getModelName(vnode);
				if (modelName != null) {
					formattedValue = vnode.context[modelName];
				}
				newValue = Utils.float(Utils.format(formattedValue));
				if (newValue <= minValue) {
					return minValue;
				}
				return null;
			};
			(function (binding, vnode) {
				var modelName = Utils.getModelName(vnode);
				el.addEventListener('blur', function (e) {
					var changedValue = getMinModelValueOrNull(binding, vnode, e.target.value);
					if (changedValue != null) {
						e.target.value = changedValue;
						if (modelName != null) {
							vnode.context[modelName] = changedValue;
						}
					}
				});
				if (modelName != null) {
					vnode.context.$watch(modelName, function (newValue) {
						var changedValue = getMinModelValueOrNull(binding, vnode, newValue);
						if (changedValue != null) {
							vnode.context[modelName] = changedValue;
						}
					});
				}
			})(binding, vnode);
		}
	});

	app.directive('model-max-value', {
		bind: function (el, binding, vnode) {
			if (!(binding.expression in vnode.context)) {
				return;
			}
			var getMaxModelValueOrNull = function (binding, vnode, newValue) {
				var formattedValue = newValue,
					maxValue = vnode.context[binding.expression],
					modelName = Utils.getModelName(vnode);
				if (modelName != null) {
					formattedValue = vnode.context[modelName];
				}
				newValue = Utils.float(Utils.format(formattedValue));
				if (newValue >= maxValue) {
					return maxValue;
				}
				return null;
			};
			(function (binding, vnode) {
				var modelName = Utils.getModelName(vnode);
				el.addEventListener('blur', function (e) {
					var changedValue = getMaxModelValueOrNull(binding, vnode, e.target.value);
					if (changedValue != null) {
						e.target.value = changedValue;
						if (modelName != null) {
							vnode.context[modelName] = changedValue;
						}
					}
				});
				if (modelName != null) {
					vnode.context.$watch(modelName, function (newValue) {
						var changedValue = getMaxModelValueOrNull(binding, vnode, newValue);
						if (changedValue != null) {
							vnode.context[modelName] = changedValue;
						}
					});
				}
			})(binding, vnode);
		}
	});

	app.directive('money', money);

	app.directive('clear-first-click', {
		bind: function (el, binding, vnode) {
			var once = function (fn) {
				var called = false;
				return function (e) {
					if (!called) {
						fn.call(this, e);
						called = true;
					}
				};
			};
			(function (binding, vnode) {
				el.addEventListener('focus', once(function (e) {
					e.target.value = '';
				}));
			})(binding, vnode);
		}
	});

	app.directive('clear', {
		bind: function (el, binding, vnode) {
			(function (binding, vnode) {
				el.addEventListener('focus', function (e) {
					e.target.value = '';
				});
			})(binding, vnode);
		},
	});

	app.directive('focus', focus);

	app.directive('phone', phone);

	app.directive('step-progress', stepProgress);

	app.directive('period', {
		bind(el) {
			el.addEventListener('focus', function (e) {
				e.target.value = '';
			});
		},
		update(el) {
			el.value = Filters.periodString(el.value);
		},
		inserted(el) {
			el.value = Filters.periodString(el.value);
		}
	});

	app.directive('days', {
		bind(el, binding, vnode) {
			focusBlurHandler(el);
		},
		update(el, binding, vnode) {
			el.value = Filters.declineDays(el.value);
		},
		inserted(el, binding, vnode) {
			el.value = Filters.declineDays(el.value);
		},
	});

	app.directive('years', {
		bind(el, binding, vnode) {
			focusBlurHandler(el);
		},
		update(el, binding, vnode) {
			el.value = Filters.declineYears(el.value);
		},
		inserted(el, binding, vnode) {
			el.value = Filters.declineYears(el.value);
		},
	});

	app.directive('score', {
		bind(el, binding, vnode) {
			focusBlurHandler(el);
		},
		update(el, binding, vnode) {
			el.value = Filters.declineScore(el.value);
		},
		inserted(el, binding, vnode) {
			el.value = Filters.declineScore(el.value);
		},
	});

	app.directive('cards', {
		bind(el, binding, vnode) {
			focusBlurHandler(el);
		},
		update(el, binding, vnode) {
			el.value = Filters.declineCards(el.value);
		},
		inserted(el, binding, vnode) {
			el.value = Filters.declineCards(el.value);
		},
	});

	app.directive('hours', {
		bind(el, binding, vnode) {
			focusBlurHandler(el);
		},
		update(el, binding, vnode) {
			el.value = Filters.declineHours(el.value);
		},
		inserted(el, binding, vnode) {
			el.value = Filters.declineHours(el.value);
		},
	});

	app.directive('atms', {
		bind(el, binding, vnode) {
			focusBlurHandler(el);
		},
		update(el, binding, vnode) {
			el.value = Filters.declineAtms(el.value);
		},
		inserted(el, binding, vnode) {
			el.value = Filters.declineAtms(el.value);
		},
	});

	app.directive('onlyNumberWithTriads', {
		bind(el) {
			el.addEventListener('input', (e) => {
				el.value = e.target.value.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
			});
		},
		componentUpdated(el) {
			if (el.value.length > 0) {
				el.value = `${el.value.replace(/\s/g, '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')}`;
			}
		}
	});

	app.directive('upperCase', {
		update(el) {
			el.value = el.value.toUpperCase();
		}
	});

	// в качестве аргумента надо передавать путь до значения вида 'bank.cardFirstName'
	app.directive('upperCardName', {
		bind: (el, binding, vnode) => {
			el.addEventListener('change', () => {
				let value = binding.value.split('.');
				if (value.length === 2 ) {
					vnode.context[binding.value.split('.')[0]][binding.value.split('.')[1]] = el.value.toUpperCase();
				}
				if (value.length === 1 ) {
					vnode.context[binding.value.split('.')[0]] = el.value.toUpperCase();
				}
			})
		},
	});
	app.directive('onlyNumber', {
		bind(el) {
			el.addEventListener('input', () => {
				el.value = el.value.replace(/\D/g, '');
			});
		}
	});
}
